import React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"
import { Href } from "../utils/helper"
import * as styles from "./sideBarCta.module.css"

const SideBarCta = ({blok}) => {
  // console.log(blok)

  return (
    <div className="min-h-[150px]" {...storyblokEditable(blok)} >
      <div className="font-serif font-bold mb-4">
        {blok.title}
      </div>
      <div className="px-3 border-l">
        <div className={`text-sm mt-4 mb-2 ${styles.richText}`} dangerouslySetInnerHTML={{__html: renderRichText(blok.description)}}></div>
      </div>
      <a href={Href(blok.ctaUrl)} className="flex items-center justify-center bg-red-600 text-white py-2 rounded-lg">
        {blok.ctaText}
        <img className="w-5 h-5 inline ml-2" src="/icons/arrow-right-white.svg" alt="Arrow right"/>
      </a>
    </div>
  )

}

export default SideBarCta
